import {createAction} from '@reduxjs/toolkit'
import {getEventId} from '@wix/wix-events-commons-statics'
import {getEvent, isDemoEvent} from '../selectors/event'
import {createAsyncAction} from '../services/redux-toolkit'

export const toggleAgreePolicies = createAction('TOGGLE_AGREE_POLICIES')

export const getPolicies = createAsyncAction<
  {policies: wix.events.Policy[]; policyAgreementToken?: string},
  {showAlert: boolean}
>(
  'GET_POLICIES',
  async (_, {getState, extra: {serverApi}}) => {
    const state = getState()
    const event = getEvent(state)

    return serverApi.getPolicies(getEventId(event))
  },
  {
    condition: (_, {getState}) => {
      return !isDemoEvent(getState())
    },
  },
)
